import MundialRequestTask from "./MundialRequestTask";

export class StructureTask extends MundialRequestTask {

  constructor() {
    super();
  }

  getUrl() {
    const baseUrl = this.getBaseUrl();
    return `${baseUrl}/leagues/${this.leagueId}/structure`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/StructureTask.ts